/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_codon_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The sequence is read in frame 1, starting at the first base. Make sure your input is a coding sequence in frame — for example beginning at the start codon.`)
};

const es_codon_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La secuencia se lee en el marco 1, comenzando en la primera base. Asegúrate de que tu entrada sea una secuencia codificante en marco — por ejemplo, que comience en el codón de inicio.`)
};

const de_codon_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Sequenz wird in Raster 1 gelesen, beginnend bei der ersten Base. Stellen Sie sicher, dass Ihre Eingabe eine im Raster liegende Kodierungssequenz ist — zum Beispiel beginnend beim Startcodon.`)
};

const nl_codon_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De sequentie wordt gelezen in frame 1, beginnend bij de eerste base. Zorg dat je invoer een coderende sequentie in frame is — bijvoorbeeld beginnend bij het startcodon.`)
};

const fr_codon_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La séquence est lue dans le cadre 1, à partir de la première base. Assurez-vous que votre entrée est une séquence codante dans le bon cadre — par exemple commençant au codon d'initiation.`)
};

const it_codon_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La sequenza viene letta nella fase 1, a partire dalla prima base. Assicurati che il tuo input sia una sequenza codificante in fase — per esempio a partire dal codone di inizio.`)
};

const pt_br2_codon_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sequência é lida no quadro 1, começando na primeira base. Certifique-se de que sua entrada seja uma sequência codificante no quadro correto — por exemplo, começando no códon de início.`)
};

const pt_codon_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sequência é lida na grelha 1, começando na primeira base. Certifique-se de que a sua entrada é uma sequência codificante em grelha — por exemplo, começando no codão de início.`)
};

const ja_codon_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列は最初の塩基から読み枠1で読み取られます。入力が開始コドンから始まるなど、読み枠に合ったコード配列であることを確認してください。`)
};

const zh_codon_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`序列从第一个碱基开始按阅读框 1 读取。请确保你输入的是处于正确阅读框中的编码序列——例如从起始密码子开始。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const codon_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.codon_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("codon_faq_a4", locale)
	if (locale === "en") return en_codon_faq_a4(inputs)
	if (locale === "es") return es_codon_faq_a4(inputs)
	if (locale === "de") return de_codon_faq_a4(inputs)
	if (locale === "nl") return nl_codon_faq_a4(inputs)
	if (locale === "fr") return fr_codon_faq_a4(inputs)
	if (locale === "it") return it_codon_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_codon_faq_a4(inputs)
	if (locale === "pt") return pt_codon_faq_a4(inputs)
	if (locale === "ja") return ja_codon_faq_a4(inputs)
	return zh_codon_faq_a4(inputs)
};